import { Box, Divider, Loader, Transition } from '@wix/design-system';
import { useExperiments } from '@wix/fe-essentials/react';
import { RulesPanelUIProvider } from '@wix/rules-panel-ui';
import { useSetAtom } from 'jotai';
import React, { useRef } from 'react';
import { scrollerNodeRefAtom } from '../../atoms/session-atoms';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
import { EditorHost } from '../../providers';
import { useVerticalDrillInScreen } from './use-vertical-drill-in-screen';
import { VerticalsDrillInBottomSection } from './verticals-drill-in-bottom-section';
import { VerticalsDrillInContent } from './verticals-drill-in-content';
import { VerticalsDrillInContentCards } from './verticals-drill-in-content-cards';
import { VerticalsDrillInTopSection } from './verticals-drill-in-top-section';
export const VerticalsDrillInScreen = () => {
  const divRef = useRef(null);
  const {
    executionResults,
    jotaiStore,
    unsavedChangedHandlersProps,
    toggleFunctions
  } = useVerticalDrillInScreen();
  const setScrollerNode = useSetAtom(scrollerNodeRefAtom);
  setScrollerNode(divRef);
  const {
    editorHost
  } = useA11yWizardAdapter();
  const {
    experiments
  } = useExperiments();
  const useNewCardsUI = experiments.enabled('specs.a11y-wizard.useCardsUI');
  if (executionResults === undefined || Object.keys(executionResults).length === 0) {
    // todo: change with real loading screen
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(Transition, {
    animateOnLoad: true,
    enterAnimation: {
      moveIn: {
        direction: 'rightToLeft',
        distance: '300px',
        duration: 'fast01',
        easing: 'enterEasing'
      }
    }
  }, /*#__PURE__*/React.createElement(RulesPanelUIProvider, {
    store: jotaiStore,
    unsavedChangesHandlers: unsavedChangedHandlersProps,
    onToggleFunctions: toggleFunctions
  }, /*#__PURE__*/React.createElement(Box, {
    bottom: "0",
    direction: "vertical",
    height: "100%",
    left: "0",
    position: "absolute",
    right: "0",
    top: "0"
  }, /*#__PURE__*/React.createElement("div", {
    ref: divRef,
    style: {
      flex: '1 1 auto',
      minHeight: '280px',
      overflowX: 'hidden',
      overflowY: 'auto',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    top: "0"
  }, /*#__PURE__*/React.createElement(VerticalsDrillInTopSection, null)), editorHost === EditorHost.odeditor || useNewCardsUI ? /*#__PURE__*/React.createElement(VerticalsDrillInContentCards, null) : /*#__PURE__*/React.createElement(VerticalsDrillInContent, null)), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(VerticalsDrillInBottomSection, null))));
};
//# sourceMappingURL=verticals-drill-in-screen.js.map